module.exports = __webpack_public_path__ + "img/waze.504fade8.png";